module.exports = __webpack_public_path__ + "img/冷冻投用2倍图.3a276e4f.webp";